var map = {
	"./en/illustratepic_01.png": "4CS4",
	"./ja/illustratepic_01.png": "gB0j",
	"./ko/illustratepic_01.png": "/v8i",
	"./zh-CN/illustratepic_01.png": "e3Po",
	"./zh-TW/illustratepic_01.png": "REVE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UbRP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/illustratepic_01\.png$
// module id = UbRP
// module chunks = 1